// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h4[data-v-3ba68255] {\n  margin-top: 1em;\n  font-weight: bold;\n}\n.container[data-v-3ba68255] {\n  text-align: start;\n}\n.text[data-v-3ba68255] {\n  margin-bottom: 1em;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
